import type { Plugins } from 'core/plugins/config/types';

/**
 * Builds an error message from a list of Plugins.
 */
export function buildErrorMsg(plugins: Plugins.Model | Plugins.Model[]) {
  const pluginsList = Array.isArray(plugins) ? plugins : [plugins];

  return pluginsList.map((mod) => `${mod.name} (requires: ${mod.requires?.join(', ')})`).join(', ');
}
